var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRunes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.763,
    height: 27.296,
    viewBox: "0 0 12.763 27.296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31.19 -9.774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5,29.312,33.952,23.4l9.281-6.159a.934.934,0,0,0,.424-.821.946.946,0,0,0-.5-.784L32.663,9.9a1.024,1.024,0,0,0-.984,0,.943.943,0,0,0-.489.818v25.4a.94.94,0,0,0,.492.821,1.011,1.011,0,0,0,.492.126,1.028,1.028,0,0,0,.5-.129l10.791-6.02a.946.946,0,0,0,.492-.8A.927.927,0,0,0,43.5,29.312Zm-10.34-16.96,7.659,4.184-7.659,5.083Zm0,22.129V25.162l7.917,4.9Z",
    transform: "translate(0)",
    fill: "#0080ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunes);
export default __webpack_public_path__ + "static/media/runes.71438aa4.svg";
export { ForwardRef as ReactComponent };